import { environment } from "src/environments/environment";

/**
 * True when the company belongs to the root tenant (HänyTec).
 */
export function isRootCompany(company: { tenantId?: string } | null | undefined): boolean {
  return company?.tenantId === environment.rootTenant;
}

/**
 * Checks an optional, per-company feature flag (e.g. `inventoryEnabled`).
 * The root tenant always has access to every module; without a feature name the check passes.
 */
export function companyHasFeature(company: any, feature: string | undefined | null): boolean {
  if (!feature) {
    return true;
  }

  return isRootCompany(company) || company?.[feature] === true;
}